"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeCentral = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
let KnowledgeCentral = class KnowledgeCentral {
    constructor(title, docTypeId, statusId, categoryId, fileName, documentId, relativePath, extension, summary, tags, accessCount = 0, createdBy = 0, updatedBy = 0, version = 1) {
        this.title = title;
        this.docTypeId = docTypeId;
        this.statusId = statusId;
        this.categoryId = categoryId;
        this.fileName = fileName;
        this.relativePath = relativePath || null;
        this.extension = extension || null;
        this.summary = summary || null;
        this.tags = tags || null;
        this.accessCount = accessCount;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.documentId = documentId; // Default to 0 if not provided
        this.version = version;
    }
};
exports.KnowledgeCentral = KnowledgeCentral;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'document_id', type: 'bigint' }),
    tslib_1.__metadata("design:type", BigInt)
], KnowledgeCentral.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 255 }),
    tslib_1.__metadata("design:type", String)
], KnowledgeCentral.prototype, "title", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'doc_type_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "docTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'status_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "statusId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'category_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "categoryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'file_name', type: 'varchar', length: 255 }),
    tslib_1.__metadata("design:type", String)
], KnowledgeCentral.prototype, "fileName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'relative_path', type: 'varchar', length: 255, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], KnowledgeCentral.prototype, "relativePath", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 20, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], KnowledgeCentral.prototype, "extension", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], KnowledgeCentral.prototype, "summary", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'int', default: 1 }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "version", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', array: true, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], KnowledgeCentral.prototype, "tags", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'access_count', type: 'int', default: 0 }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "accessCount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: 'created_at' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], KnowledgeCentral.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: 'updated_at' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], KnowledgeCentral.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: 'deleted_at', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], KnowledgeCentral.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'created_by', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'updated_by', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], KnowledgeCentral.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: 'doc_type_id', referencedColumnName: 'id' }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], KnowledgeCentral.prototype, "docType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: 'status_id', referencedColumnName: 'id' }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], KnowledgeCentral.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: 'category_id', referencedColumnName: 'id' }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], KnowledgeCentral.prototype, "category", void 0);
exports.KnowledgeCentral = KnowledgeCentral = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: 'knowledge_central' }),
    (0, typeorm_1.Index)('idx_kc_doc_status', ['documentId', 'statusId']),
    (0, typeorm_1.Index)('uq_kc_doc_version', ['documentId', 'version'], { unique: true }),
    tslib_1.__metadata("design:paramtypes", [String, Number, Number, Number, String, BigInt, Object, Object, Object, Object, Number, Number, Number, Number])
], KnowledgeCentral);
